<script>
    import {createEventDispatcher} from 'svelte';

    import Caja from "../../UI/Caja.svelte";
    import {url} from '@sveltech/routify';

    import Boton from "../../UI/Boton.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import Icono from "../../UI/Icono.svelte";
    import Tooltip from "../../UI/Tooltip.svelte";

    export let sede;

    const dispatch = createEventDispatcher();

    const eliminarSede = () => dispatch('eliminar-sede', sede);
    let tooltip = false;
</script>

<style>
    .acciones {
        text-align: right;
    }

    dt, dd {
        display: inline;
        margin: 0;
        padding: 0;
    }

    dd a {
        color: currentColor;
    }

    dt {
        font-weight: 600;
    }

    dt:after {
        content: ':';
        margin-right: .5em;
    }

    dd:after {
        content: '\A';
        white-space: pre;
    }

    .nombre {
        display: flex;
        flex-direction: row-reverse;
    }

    .calendario {
        margin-right: .5em;
        position: relative;
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>
            {sede.nombre}
        </Subtitulo>
    </div>

    <div slot="pie" class="acciones">
        <Boton href={$url(`/sedes/${sede.id}/editar`)} icono="edit" tipo="ok">Editar
        </Boton>
        <Boton on:click={eliminarSede} icono="delete" tipo="peligro">Borrar</Boton>
    </div>
</Caja>